type CalculateAvailableCanvasHeightParams = {
  containerHeight: number;
  containerTop: number;
  instructionsHeight: number;
  navigationTop: number;
  gap: number;
};

const calculateAvailableCanvasHeight = ({
  containerHeight,
  containerTop,
  instructionsHeight,
  navigationTop,
  gap,
}: CalculateAvailableCanvasHeightParams): number => {
  const availableHeight = navigationTop - containerTop - instructionsHeight - gap;

  if (availableHeight <= 0) {
    return containerHeight;
  }

  return Math.min(containerHeight, availableHeight);
};

type GetAvailableCanvasHeightParams = {
  containerElement: HTMLDivElement | null;
  containerHeight: number;
  instructionsElement: HTMLDivElement | null;
  isLandscapeSas: boolean;
  navigationElement: HTMLDivElement | null;
};

export const getAvailableCanvasHeight = ({
  containerElement,
  containerHeight,
  instructionsElement,
  isLandscapeSas,
  navigationElement,
}: GetAvailableCanvasHeightParams): number => {
  if (!isLandscapeSas || !navigationElement || !instructionsElement || !containerElement) {
    return containerHeight;
  }

  const { marginBottom, marginTop } = window.getComputedStyle(instructionsElement);
  const instructionsHeight =
    Math.max(instructionsElement.offsetHeight, instructionsElement.scrollHeight) +
    (Number.parseFloat(marginTop) || 0) +
    (Number.parseFloat(marginBottom) || 0);

  return calculateAvailableCanvasHeight({
    containerHeight,
    containerTop: containerElement.getBoundingClientRect().top,
    instructionsHeight,
    navigationTop: navigationElement.getBoundingClientRect().top,
    gap: 8,
  });
};
